import { atom } from "jotai";

export const evaluacionesHistoricosAtom = atom([]);
//export const evaluacionPendienteSeleccionadaAtom = atom();

//pendientes evaluacion
export const evaluacionesPendientesAtom = atom([]);
export const evaluacionPendienteSeleccionadaAtom = atom(undefined);
export const visibleModalEvaluacionPendienteAtom = atom(false);

export const visibleModalFirmarEvaluacionAtom = atom(false);

export const frmPreguntasCalidadAtom = atom(undefined);
export const frmPreguntasProactividadAtom = atom(undefined);
export const frmPreguntasTrabajoEnEquipoAtom = atom(undefined);
export const frmPreguntasOrientacionResultadosAtom = atom(undefined);
export const frmPreguntasRelacionesInterpersonalesAtom = atom(undefined);
export const frmPreguntasLimpiezaSeguridadAtom = atom(undefined);
export const frmObservacionResultadosAtom = atom(undefined);
export const frmPlanAccionAtom = atom(undefined);
export const frmRenovacionAtom = atom(undefined);

export const puntajeTotalCalidadAtom = atom(0);
export const puntajeTotalProactividadAtom = atom(0);
export const puntajeTotalTrabajoEnEquipoAtom = atom(0);
export const puntajeTotalOrientacionResultadosAtom = atom(0);
export const puntajeTotalRelacionesInterpersonalesAtom = atom(0);
export const puntajeTotalLimpiezaSeguridadAtom = atom(0);
export const puntajeTotalEvaluacionAtom = atom(0);

//plan de Accion
export const planesAccionAtom = atom([]);
export const planAccionSeleccionadaAtom = atom(undefined);
export const visibleModalActualizarPlanAccionAtom = atom(false);

export const visibleModalEvaluacionConductorAtom = atom(false);
export const frmPreguntasPuntualidadAtom = atom(undefined);
export const puntajeTotalPuntualidadAtom = atom(0);
export const frmPreguntasComunicacionReportesAtom = atom(undefined);
export const puntajeTotalComunicacionReportesAtom = atom(0);
export const frmPreguntasResponsabilidadManejoVehiculoAtom = atom(undefined);
export const puntajeTotalResponsabilidadManejoVehiculoAtom = atom(0);
export const frmPreguntasActitudTrabajoEquipoAtom = atom(undefined);
export const puntajeTotalActitudTrabajoEquipoAtom = atom(0);
export const frmPreguntasImagenRepresentacionEmpresaAtom = atom(undefined);
export const puntajeTotalImagenRepresentacionEmpresaAtom = atom(0);
export const frmPreguntasPredisposicionAtom = atom(undefined);
export const puntajeTotalPredisposicionAtom = atom(0);
export const puntajeTotalEvaluacionConductorAtom = atom(0);

export const visibleModalEvaluacionMecanicoAtom = atom(false);
export const frmPreguntasConocimientosTecnicosAtom = atom(undefined);
export const puntajeTotalConocimientosTecnicosAtom = atom(0);
export const frmPreguntasCalidadTrabajoAtom = atom(undefined);
export const puntajeTotalCalidadTrabajoAtom = atom(0);
export const frmPreguntasProductividadEficienciaAtom = atom(undefined);
export const puntajeTotalProductividadEficienciaAtom = atom(0);
export const frmPreguntasResponsabilidadPuntualidadAtom = atom(undefined);
export const puntajeTotalResponsabilidadPuntualidadAtom = atom(0);
export const frmPreguntasTrabajoEquipoActitudAtom = atom(undefined);
export const puntajeTotalTrabajoEquipoActitudAtom = atom(0);
export const frmPreguntasResolucionProblemaTomaDecisionesAtom = atom(undefined);
export const puntajeTotalResolucionProblemaTomaDecisionesAtom = atom(0);
export const puntajeTotalEvaluacionMecanicoAtom = atom(0);